























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Setting as ISetting } from '@/types';
import { UtilService } from '@/services';
import UpTags from '../Common/UpTags.vue';
import TextEditor from '@/components/Common/TextEditor.vue';
import { faSpinner, faSave } from '@fortawesome/pro-light-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faSpinner, faSave);

@Component({
  name: 'setting',
  components: {
    UpTags,
    TextEditor
  }
})
export default class Setting extends Vue {
  @Prop()
  setting!: ISetting;

  private thisSetting: ISetting = UtilService.toObject(this.setting);
  private toTitle = UtilService.toTitle;
  private canSave = false;
  private saving = false;

  get showSaveButton(): boolean {
    return (
      this.thisSetting.editable &&
      (this.thisSetting.type === 'text' ||
        this.thisSetting.type === 'textarea' ||
        this.thisSetting.type === 'number' ||
        this.thisSetting.type === 'richtext')
    );
  }

  onSettingChange(value: any) {
    this.thisSetting.value = value;
    this.canSave = this.setting.value !== value;

    if (this.thisSetting.type === 'boolean') {
      this.updateSetting(value);
    }
  }

  async updateSetting(value?: any) {
    this.saving = true;
    await this.$store.dispatch('updateSetting', this.thisSetting);
    this.$notify.success(`${this.toTitle(this.thisSetting.key)} Updated`);
    this.saving = false;
    this.canSave = false;
  }

  async addListSettingItem(item: any) {
    this.saving = true;
    try {
      await this.$store.dispatch('addListSettingItem', {
        id: this.thisSetting.id,
        item: item
      });
      this.thisSetting.value.push(item);
      this.$notify.success(
        `New ${this.toTitle(this.thisSetting.key)} ${item} Added`
      );
    } catch (e) {
      this.$notify.error(
        `Fail to add new ${this.toTitle(this.thisSetting.key)} ${item}.`
      );
      this.saving = false;
    }
    this.saving = false;
    this.canSave = false;
  }

  async removeListSettingItem(item: any) {
    this.saving = true;
    try {
      await this.$store.dispatch('removeListSettingItem', {
        id: this.thisSetting.id,
        item: item
      });
      this.thisSetting.value.splice(this.thisSetting.value.indexOf(item), 1);
      this.$notify.success(
        `${this.toTitle(this.thisSetting.key)} ${item} removed.`
      );
    } catch (e) {
      this.$notify.error(
        `Fail to remove ${this.toTitle(this.thisSetting.key)} ${item}.`
      );
      this.saving = false;
    }
    this.saving = false;
    this.canSave = false;
  }
}
